import reduxStore from "../reduxStore";

export const getMaintenanceMode = () => {
  return reduxStore.getState().versionping.maintenance;
};

window.getMaintenanceMode = getMaintenanceMode;
